import type { MissingGame } from '../../../../../types/features/games';

export const formatDateTime = (value: string) => new Intl.DateTimeFormat(undefined, {
  dateStyle: 'medium',
  timeStyle: 'short',
}).format(new Date(value));

export const valueWithConflicts = (current: string, values: Array<string | number>) => (
  values.length > 1 ? `${current} (${values.join(', ')})` : current
);

export const formatPluGenerationTooltip = (game: MissingGame) => {
  const generation = game.plu_generation;
  const details = [
    ['method', generation?.method],
    ['base_number', generation?.base_number],
  ];

  return details
    .filter(([, value]) => value)
    .map(([label, value]) => `${label}: ${value}`)
    .join('\n');
};
